import React, { useReducer, useEffect, useContext } from "react";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import { storage, functions, constants } from "../../../utils";
import api from "../../../utils/api";
import formatting from "../../../utils/formatHelpers";
import toast from "react-hot-toast";
import { Link as DomLink } from "react-router-dom";
import {
  AppContext,
  ProductsContext,
} from "../../../utils/stateHandlers/contexts";
import { productReducer } from "../../../utils/stateHandlers/reducers";
import states from "../../../utils/stateHandlers/initialStates";
import qs from "qs";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import _ from "lodash";
import ProductGalleryViewer from "../components/ProductGalleryViewer";
import DetailTable from "../components/DetailTable";
import Price from "../components/Price";
import HorizontalScrollList from "../components/HorizontalScrollList";
import ProductSeries from "../components/ProductSeries";
import TechnicalArticles from "../components/TechnicalArticles";
import CustomerTestimonials from "../components/CustomerTestimonials";
import SpecialInstructions from "../components/SpecialInstructions";
import TreatmentField from "../components/TreatmentField";
import FillerImage from "../../../assets/images/Filler-Harmony-8-1-22.gif";
import Container from "@mui/material/Container";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import WasherImage from "../../../assets/images/WAS_S_XLG.png";
import CircleImage from "../../../assets/images/CIR_S_XLG.png";
import RingBlanks1 from "../../../assets/images/WRB_S_XLG.png";
import RingBlanks2 from "../../../assets/images/WRB_DIAGRAM_XLG.png";
import Material from "../components/productFields/Material";
import Dimension from "../components/productFields/Dimension";
import CaratSize from "../components/productFields/CaratSize";
import FingerSize from "../components/productFields/FingerSize";
import OuterDiameter from "../components/productFields/OuterDiameter";
import InnerDiameter from "../components/productFields/InnerDiameter";
import Quantity from "../components/productFields/Quantity";
import Length from "../components/productFields/Length";
import Width from "../components/productFields/Width";
import Thickness from "../components/productFields/Thickness";
import QuantityPieces from "../components/productFields/QuantityPieces";
import QuantityLength from "../components/productFields/QuantityLength";

export default function ProductDetailPage(props) {
  const { authToken } = useContext(AppContext);
  const [productState, productDispatch] = useReducer(
    productReducer,
    states.initialProductState
  );
  const {
    pageLoaded,
    productSeries,
    productGroup,
    productInfo,
    images,
    productDetails,
    style,
    icons,
    productFields,
    productTreatments,
    compatibleProducts,
    relatedProducts,
    metalColumns,
    strapiChart,
    TopText,
    BottomText,
    ChartSizeSmall,
    circleDimension,
  } = productState;
  const productCode = props.match.params.ProductStyleCode;
  const twoPartStyleCode = `${props.match.params.ProductStyleCode}/${props.match.params.ProductStyleCodeSecondPart}`;
  const threePartStyleCode = `${props.match.params.ProductStyleCode}/${props.match.params.ProductStyleCodeSecondPart}/${props.match.params.ProductStyleCodeThirdPart}`;
  const frontImageUrl = constants.CMS_FRONT_IMAGE_URL;

  //initial page loads
  function createProductDefaults(product) {
    var productDefaults = {};
    productDefaults = {
      ...productDefaults,
      product: product.product,
      description: product.description,
      treatments: "",
      dimension: setInitialDimension(product),
      quantity: setInitialQuantity(product),
      quantity_unit: setInitialQuantityUnit(product),
    };
    productDispatch({
      type: "setStyle",
      payload: product,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "product",
      payload: product.product,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "description",
      payload: product.description,
    });
    productDispatch({
      type: "setProductDefaults",
      field: "treatments",
      payload: "",
    });
    productDispatch({
      type: "setProductDefaults",
      field: "dimension",
      payload: setInitialDimension(product),
    });
    productDispatch({
      type: "setProductDefaults",
      field: "quantity",
      payload: setInitialQuantity(product),
    });
    productDispatch({
      type: "setProductDefaults",
      field: "quantity_unit",
      payload: setInitialQuantityUnit(product),
    });
    _.forEach(product.fields, function (field) {
      if (field.name !== "dimension" && field.name !== "quantity") {
        if (field.template === "field_with_units") {
          productDispatch({
            type: "setProductDefaults",
            field: field.name,
            payload: field.default,
          });
          productDispatch({
            type: "setProductDefaults",
            field: `${field.name}_unit`,
            payload: field.default_unit,
          });
          productDefaults = {
            ...productDefaults,
            [field.name]: field.default,
            [`${field.name}_unit`]: field.default_unit,
          };
        } else {
          productDispatch({
            type: "setProductDefaults",
            field: field.name,
            payload: field.default,
          });
          productDefaults = {
            ...productDefaults,
            [field.name]: field.default,
          };
        }
      }
    });
    if (authToken) {
      getInitialPrice(productDefaults);
    } else {
      productDispatch({ type: "setPriceLoaded", payload: true });
    }
  }

  function setInitialDimension(initialProduct) {
    if (productCode === "CIR") {
      const cirDim = _.find(initialProduct.fields, function (field) {
        return field.name === "dimension";
      });
      productDispatch({
        type: "setCircleDimension",
        payload: cirDim.default,
      });
      return "01x20GA";
    } else if (productCode === "WAS") {
      return "03x01x20GA";
    } else if (productCode === "FS") {
      return "1INx1INx20GA";
    } else if (productCode === "RW") {
      return ".032IN";
    } else if (
      productCode === "DSK" ||
      productCode === "AE" ||
      productCode === "ML" ||
      productCode === "SD" ||
      productCode === "SDC" ||
      productCode === "SR" ||
      productCode === "SDB" ||
      productCode === "SRB" ||
      props.ProductGroup === "WireTubing"
    ) {
      const dimField = _.find(initialProduct.fields, function (field) {
        return field.name === "dimension";
      });
      return dimField.default;
    } else {
      return initialProduct.dimension;
    }
  }

  function setInitialQuantity(initialProduct) {
    const pieces = _.find(initialProduct.fields, function (field) {
      return field.name === "quantity.pieces";
    });
    const length = _.find(initialProduct.fields, function (field) {
      return field.name === "quantity.length";
    });
    const quantityLengthField = _.find(initialProduct.fields, function (field) {
      return field.name === "quantity.length";
    });
    const quantityField = _.find(initialProduct.fields, function (field) {
      return field.name === "quantity";
    });
    const quantity =
      pieces && length
        ? `${pieces.default}-${length.default}`
        : quantityLengthField
        ? quantityLengthField.default
        : quantityField.default;
    return quantity;
  }

  function setInitialQuantityUnit(initialProduct) {
    if (props.ProductGroup === "WireTubing") {
      const quantityField = _.find(initialProduct.fields, function (field) {
        return field.name === "quantity.length";
      });
      return quantityField.default_unit;
    } else {
      const quantityField = _.find(initialProduct.fields, function (field) {
        return field.name === "quantity";
      });
      return quantityField.default_unit;
    }
  }

  function makeInitialQueryString(productDefaults) {
    const query = qs.stringify({
      product: productDefaults.product,
      dimension: productDefaults.dimension,
      quantity: productDefaults.quantity,
      quantity_unit: productDefaults.quantity_unit,
      material: productDefaults.material,
      carat_size: productDefaults.carat_size,
      message: productDefaults.message,
      finger_size: productDefaults.finger_size,
      treatments: "",
    });
    return query;
  }

  function getInitialPrice(productDefaults) {
    const query = makeInitialQueryString(productDefaults);
    api.fetch(`quickorder/price?${query}`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
        productDispatch({
          type: "setMessage",
          payload: {
            message: _.values(response.response.data.errors),
            type: "error",
          },
        });
      } else {
        productDispatch({ type: "setPrice", payload: response.data });
        productDispatch({ type: "setPriceLoaded", payload: true });
      }
    });
  }

  //update functions
  function setDimension() {
    if (productCode === "CIR") {
      return `${circleDimension}x${productInfo.thickness}${productInfo.thickness_unit}`;
    } else if (productCode === "WAS") {
      return `${productInfo.outer_diameter}x${productInfo.inner_diameter}x${productInfo.thickness}${productInfo.thickness_unit}`;
    } else if (productCode === "FS") {
      return `${productInfo.length}${productInfo.length_unit}x${productInfo.width}${productInfo.width_unit}x${productInfo.thickness}${productInfo.thickness_unit}`;
    } else {
      return productInfo.dimension;
    }
  }

  function setTreatmentsString() {
    const treatmentsList = _.map(productInfo.treatments, function (treatment) {
      return treatment.value;
    });
    return _.join(treatmentsList, " ");
  }

  function makeQueryString() {
    const infoToStrignify = {
      product: productInfo.product,
      dimension: setDimension(),
      quantity:
        props.ProductGroup === "WireTubing"
          ? `${productInfo["quantity.pieces"]}-${productInfo["quantity.length"]}`
          : productInfo.quantity,
      quantity_unit:
        props.ProductGroup === "WireTubing"
          ? productInfo["quantity.length_unit"]
          : productInfo.quantity_unit,
      material: productInfo.material,
      carat_size: productInfo.carat_size,
      message: productInfo.message,
      finger_size: productInfo.finger_size,
      treatments: setTreatmentsString(),
    };
    const arrayOfValues = _.values(infoToStrignify);
    const searchingForNone = _.includes(arrayOfValues, "None");
    if (!searchingForNone) {
      const query = qs.stringify(infoToStrignify);
      return query;
    } else {
      productDispatch({ type: "setPriceLoaded", payload: true });
      return false;
    }
  }

  function getUpdatedPrice(newQueryString) {
    api.fetch(`quickorder/price?${newQueryString}`).then((response) => {
      if (response.isAxiosError) {
        const errorMessage = [];
        _.forEach(response.response.data.errors, function (error) {
          errorMessage.push(error);
        });
        console.log(errorMessage);
        toast.error(
          `There was an error processing your request. ${_.toString(
            errorMessage
          )}`
        );
        productDispatch({
          type: "setMessage",
          payload: {
            message: _.values(response.response.data.errors),
            type: "error",
          },
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
      } else {
        if (
          productCode !== "FS" &&
          productCode !== "ALL" &&
          productCode !== "WRB" &&
          productCode !== "RW"
        ) {
          updateFields(response.data.fields);
        }
        productDispatch({
          type: "setNewTreatmentFields",
          payload: response.data.treatments,
        });
        productDispatch({ type: "updatePrice", payload: response.data });
        productDispatch({
          type: "setMessage",
          payload: { message: null, type: null },
        });
        productDispatch({ type: "setPriceLoaded", payload: true });
      }
    });
  }

  function updateFields(fields) {
    const newFields = [];
    _.find(productFields, function (field) {
      newFields.push(
        field.name === "material" ||
          field.name === "length" ||
          field.name === "width" ||
          field.name === "thickness" ||
          field.name === "outer_diameter" ||
          field.name === "inner_diameter"
          ? field
          : null
      );
    });
    _.forEach(fields, function (field) {
      newFields.push(
        field.name === "quantity"
          ? field
          : field.name === "dimension"
          ? field
          : field.name === "quantity.pieces"
          ? field
          : field.name === "quantity.length"
          ? field
          : field.name === "carat_size"
          ? field
          : field.name === "finger_size"
          ? field
          : null
      );
    });
    const filteredFields = _.uniq(_.without(newFields, null));
    const sortedFields = sortFields(filteredFields);
    productDispatch({
      type: "setNewFields",
      payload: sortedFields,
    });
  }

  function sortFields(fields) {
    const newSortedFields = [];
    _.forEach(fields, function (field) {
      const newField = _.assignIn(
        {
          SortOrder:
            field.name === "material"
              ? 1
              : field.name === "dimension"
              ? 2
              : field.name === "carat_size"
              ? 3
              : field.name === "finger_size"
              ? 4
              : field.name === "quantity"
              ? 5
              : field.name === "outer_diameter"
              ? 10
              : field.name === "inner_diameter"
              ? 11
              : field.name === "quantity.pieces"
              ? 12
              : field.name === "quantity.length"
              ? 13
              : field.name === "length"
              ? 20
              : field.name === "width"
              ? 21
              : field.name === "thickness"
              ? 22
              : 100,
        },
        field
      );
      newSortedFields.push(newField);
    });
    return _.sortBy(newSortedFields, "SortOrder");
  }

  //initial load
  useEffect(() => {
    productDispatch({ type: "setPageLoaded", payload: false });
    productDispatch({ type: "setPriceLoaded", payload: false });
    productDispatch({ type: "setValidationErrors", payload: [] });
    api
      .fetch(
        `quickorder/form?style=${
          props.match.params.ProductStyleCodeThirdPart
            ? threePartStyleCode
            : props.match.params.ProductStyleCodeSecondPart
            ? twoPartStyleCode
            : productCode
        }`
      )
      .then((response) => {
        if (response.isAxiosError) {
          const errorMessage = [];
          _.forEach(response.response.data.errors, function (error) {
            errorMessage.push(error);
          });
          console.log(errorMessage);
          toast.error(
            `There was an error processing your request. ${_.toString(
              errorMessage
            )}`
          );
        } else {
          createProductDefaults(response.data);
          functions.storeRecentlyViewed(response.data);
          productDispatch({ type: "setPageLoaded", payload: true });
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.ProductStyleCode]);

  //strapi
  useEffect(() => {
    if (
      props.isMill ||
      productCode === "CIR" ||
      productCode === "WAS" ||
      productCode === "WRB"
    ) {
      const strapiId =
        productCode === "GR"
          ? 1
          : productCode === "SD"
          ? 2
          : productCode === "SR"
          ? 47
          : productCode === "SDC"
          ? 48
          : productCode === "SDB"
          ? 2
          : productCode === "SDW"
          ? 46
          : productCode === "FS"
          ? 4
          : productCode === "ALL"
          ? 5
          : productCode === "DSK"
          ? 37
          : productCode === "AE"
          ? 38
          : productCode === "BUL"
          ? 36
          : productCode === "ML"
          ? 39
          : productCode === "FLX"
          ? 40
          : productCode === "SRB"
          ? 42
          : productCode === "CIR"
          ? 43
          : productCode === "WRB"
          ? 49
          : productCode === "WAS"
          ? 45
          : productCode === "RW"
          ? 3
          : productCode === "SRW"
          ? 6
          : productCode === "SWF"
          ? 7
          : productCode === "SWH"
          ? 8
          : productCode === "SHR"
          ? 9
          : productCode === "LDW"
          ? 10
          : productCode === "SWS"
          ? 11
          : productCode === "SWO"
          ? 12
          : productCode === "SWE"
          ? 13
          : productCode === "STW"
          ? 14
          : productCode === "DHR"
          ? 15
          : productCode === "SWT"
          ? 16
          : productCode === "SWP"
          ? 17
          : productCode === "CHW"
          ? 18
          : productCode === "BZS"
          ? 19
          : productCode === "BZW"
          ? 20
          : productCode === "BSC"
          ? 21
          : productCode === "BSR"
          ? 22
          : productCode === "CZY"
          ? 23
          : productCode === "WSQ"
          ? 24
          : productCode === "LW"
          ? 25
          : productCode === "SWD"
          ? 26
          : productCode === "SWR"
          ? 27
          : productCode === "TBL"
          ? 28
          : productCode === "TBM"
          ? 29
          : productCode === "TBH"
          ? 30
          : productCode === "TBX"
          ? 31
          : productCode === "TSL"
          ? 32
          : productCode === "TSM"
          ? 33
          : productCode === "TSH"
          ? 34
          : productCode === "TSX"
          ? 35
          : 1;
      const query = qs.stringify({
        populate: {
          left: {
            populate: "*",
          },
          middle: {
            populate: "*",
          },
          right: {
            populate: "*",
          },
          chart: {
            populate: "*",
          },
        },
      });
      api
        .fetchStrapi(`/product-details-charts/${strapiId}?${query}`)
        .then((response) => {
          productDispatch({
            type: "setStrapi",
            payload: {
              left: response.data.data.attributes.left,
              middle: response.data.data.attributes.middle,
              right: response.data.data.attributes.right,
              chart: response.data.data.attributes.chart,
              ChartSizeSmall: response.data.data.attributes.ChartSizeSmall,
              TopText: response.data.data.attributes.TopText,
              BottomText: response.data.data.attributes.BottomText,
            },
          });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.isMill, props.match.params.ProductStyleCode]);

  //update price
  useEffect(() => {
    if (authToken && pageLoaded) {
      if (props.ProductGroup === "WireTubing") {
        productDispatch({ type: "setPriceLoaded", payload: false });
        const newQueryString = makeQueryString();
        newQueryString !== false && getUpdatedPrice(newQueryString);
      } else if (productInfo.quantity > 0) {
        productDispatch({ type: "setPriceLoaded", payload: false });
        const newQueryString = makeQueryString();
        newQueryString !== false && getUpdatedPrice(newQueryString);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productInfo]);

  return (
    <ProductsContext.Provider value={{ productState, productDispatch }}>
      {!pageLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl">
          <Mobile>
            <Stack spacing={2}>
              <Stack spacing={1} className="center">
                <Typography variant="h4">{style}</Typography>
                <Typography>
                  {productInfo.description &&
                    formatting["decodeHtml"](productInfo.description)}
                </Typography>
                <Stack direction="row" spacing={1}>
                  {icons &&
                    icons.map((icons, key) => (
                      <Typography key={icons} className="icons">
                        {functions.getIcons(icons)}
                      </Typography>
                    ))}
                </Stack>
              </Stack>
              <Divider flexItem />
              <ProductGalleryViewer
                images={
                  productCode === "WAS"
                    ? [WasherImage]
                    : productCode === "CIR"
                    ? [CircleImage]
                    : productCode === "WRB"
                    ? [RingBlanks1, RingBlanks2]
                    : images
                }
              />
              <Divider flexItem sx={{ paddingBottom: ".2rem" }} />
              <Stack spacing={2} sx={{ marginBottom: "8rem" }}>
                {productFields &&
                  productFields.map((field) => {
                    if (field.name === "material") {
                      return (
                        <Material
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "dimension") {
                      return (
                        <Dimension
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "carat_size") {
                      return (
                        <CaratSize
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "finger_size") {
                      return (
                        <FingerSize
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "outer_diameter") {
                      return (
                        <OuterDiameter
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "inner_diameter") {
                      return (
                        <InnerDiameter
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "quantity") {
                      return (
                        <Quantity
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "length") {
                      return (
                        <Length
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "width") {
                      return (
                        <Width
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "thickness") {
                      return (
                        <Thickness
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "quantity.pieces") {
                      return (
                        <QuantityPieces
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else if (field.name === "quantity.length") {
                      return (
                        <QuantityLength
                          field={field}
                          key={field.name}
                          isMill={props.isMill}
                        />
                      );
                    } else {
                      return "";
                    }
                  })}
                {productTreatments &&
                  productTreatments.map((treat) => {
                    return <TreatmentField field={treat} key={treat.label} />;
                  })}
                <SpecialInstructions />
                {(productGroup === "All Settings" ||
                  productGroup === "All Shanks") && (
                  <DomLink
                    to={{
                      pathname: `/ring/build/${style}`,
                      state: {
                        productGroup: productGroup,
                        baring: true,
                        recentlyViewed: JSON.parse(
                          storage.getSessionStorageItem(
                            "hsRecentlyViewedProducts"
                          )
                        ),
                      },
                    }}
                  >
                    <Button variant="contained" sx={{ width: "100%" }}>
                      Build A Ring
                    </Button>
                  </DomLink>
                )}
                <Price ProductGroup={props.ProductGroup} />
                <DetailTable data={productDetails} />
                {!props.isMill && (
                  <>
                    <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                      Compatible Products
                    </Typography>
                    {compatibleProducts && (
                      <HorizontalScrollList
                        loadedStyles={compatibleProducts}
                        compatible={true}
                      />
                    )}
                  </>
                )}
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  {props.isMill ? "Other Items You May Like" : "Related items"}
                </Typography>
                {relatedProducts && (
                  <HorizontalScrollList
                    loadedStyles={relatedProducts}
                    related={true}
                  />
                )}
                {strapiChart && (
                  <>
                    <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                      Product Series
                    </Typography>
                    <img
                      src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                      width="100%"
                      alt="banner"
                    />
                  </>
                )}
                <TechnicalArticles />
                <CustomerTestimonials />
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Recently Viewed
                </Typography>
                {props.RecentlyViewed && (
                  <HorizontalScrollList loadedStyles={props.RecentlyViewed} />
                )}
              </Stack>
            </Stack>
          </Mobile>
          <Default>
            <Grid container spacing={6} sx={{ marginBottom: "1rem" }}>
              <Grid item xs={5} sx={{ borderRight: "2px solid #e3e3e3" }}>
                <Stack>
                  <ProductGalleryViewer
                    images={
                      productCode === "WAS"
                        ? [WasherImage]
                        : productCode === "CIR"
                        ? [CircleImage]
                        : productCode === "WRB"
                        ? [RingBlanks1, RingBlanks2]
                        : images
                    }
                  />
                  <DetailTable data={productDetails} />
                </Stack>
              </Grid>
              <Grid item xs={4}>
                <Stack spacing={1} sx={{ marginBottom: ".5rem" }}>
                  <Typography variant="h4">{style}</Typography>
                  <Typography>
                    {productInfo.description &&
                      formatting["decodeHtml"](productInfo.description)}
                  </Typography>
                  <Stack direction="row" spacing={1}>
                    {icons &&
                      icons.map((icons, key) => (
                        <Typography key={icons} className="icons">
                          {functions.getIcons(icons)}
                        </Typography>
                      ))}
                  </Stack>
                </Stack>
                <Stack spacing={3}>
                  {productFields &&
                    productFields.map((field) => {
                      if (field.name === "material") {
                        return (
                          <Material
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "dimension") {
                        return (
                          <Dimension
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "carat_size") {
                        return (
                          <CaratSize
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "finger_size") {
                        return (
                          <FingerSize
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "outer_diameter") {
                        return (
                          <OuterDiameter
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "inner_diameter") {
                        return (
                          <InnerDiameter
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "quantity") {
                        return (
                          <Quantity
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "length") {
                        return (
                          <Length
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "width") {
                        return (
                          <Width
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "thickness") {
                        return (
                          <Thickness
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "quantity.pieces") {
                        return (
                          <QuantityPieces
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else if (field.name === "quantity.length") {
                        return (
                          <QuantityLength
                            field={field}
                            key={field.name}
                            isMill={props.isMill}
                          />
                        );
                      } else {
                        return "";
                      }
                    })}
                  {productTreatments.length > 0 && <Divider flexItem />}
                  {productTreatments &&
                    productTreatments.map((treat) => {
                      return (
                        <TreatmentField
                          field={treat}
                          key={treat.label}
                          isMill={props.isMill}
                        />
                      );
                    })}
                  {productTreatments.length > 0 && <Divider flexItem />}
                  <SpecialInstructions />
                  {props.location.state &&
                    props.location.state.showBAR &&
                    compatibleProducts.length > 0 && (
                      <DomLink
                        to={{
                          pathname: `/ring/build/${style}`,
                          state: {
                            productGroup: productGroup,
                            baring: true,
                            recentlyViewed: JSON.parse(
                              storage.getSessionStorageItem(
                                "hsRecentlyViewedProducts"
                              )
                            ),
                          },
                        }}
                      >
                        <Button variant="contained" sx={{ width: "100%" }}>
                          Build A Ring
                        </Button>
                      </DomLink>
                    )}
                </Stack>
              </Grid>
              <Grid item xs={3}>
                <Price
                  isMill={props.isMill}
                  ProductGroup={props.ProductGroup}
                />
              </Grid>
            </Grid>
            {metalColumns && (
              <>
                <Divider flexItem />
                <Grid container spacing={20} justifyContent="center">
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.left}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.middle}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography variant="staticText">
                      <ReactMarkdown remarkPlugins={[remarkGfm]}>
                        {metalColumns.right}
                      </ReactMarkdown>
                    </Typography>
                  </Grid>
                </Grid>
              </>
            )}
            {strapiChart && (
              <>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  {productCode === "GR"
                    ? "Casting Grain Specifications"
                    : "Product Series"}
                </Typography>
                {TopText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {TopText}
                    </ReactMarkdown>
                  </Typography>
                )}
                {ChartSizeSmall ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                  >
                    <Grid item xs={6} className="center">
                      <img
                        src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                        width="100%"
                        alt="banner"
                      />
                    </Grid>
                    <Grid item xs={6} className="center">
                      <img src={FillerImage} alt="filler for small table" />
                    </Grid>
                  </Grid>
                ) : (
                  <img
                    src={`${frontImageUrl}${strapiChart.data.attributes.url}`}
                    width="100%"
                    alt="banner"
                  />
                )}
                {BottomText && (
                  <Typography variant="staticText">
                    <ReactMarkdown remarkPlugins={[remarkGfm]}>
                      {BottomText}
                    </ReactMarkdown>
                  </Typography>
                )}
              </>
            )}
            {!props.isMill && (
              <>
                <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                  Compatible Products
                </Typography>
                {compatibleProducts && (
                  <HorizontalScrollList
                    loadedStyles={compatibleProducts}
                    compatible={true}
                  />
                )}
              </>
            )}
            {!props.isMill && productSeries !== false && (
              <ProductSeries data={productSeries} />
            )}
            <Typography variant="h2" sx={{ marginTop: "2rem" }}>
              {props.isMill ? "Other Items You May Like" : "Related items"}
            </Typography>
            {relatedProducts && (
              <HorizontalScrollList
                loadedStyles={relatedProducts}
                related={true}
              />
            )}
            <div>
              <TechnicalArticles />
              <CustomerTestimonials />
            </div>
            <Typography variant="h2" sx={{ marginTop: "2rem" }}>
              Recently Viewed
            </Typography>
            {props.RecentlyViewed && (
              <HorizontalScrollList loadedStyles={props.RecentlyViewed} />
            )}
          </Default>
        </Container>
      )}
    </ProductsContext.Provider>
  );
}
